let rootSelector = state => state.scroll;

export const setRootSelector = selector => {
  rootSelector = selector;
};

export const isScrolled = state => rootSelector(state)?.isScrolled;
export const getAxis = state => rootSelector(state)?.axis;
